import { z } from 'zod';

// Base utility schemas for form handling
export const rhfOptionalNumber = z
    .union([z.string(), z.number()])
    .transform(val => {
        if (val === '' || val === null || val === undefined) return undefined;
        const num = Number(val);
        return isNaN(num) ? undefined : num;
    })
    .pipe(z.number().optional());

export const rhfOptionalIntNumber = z
    .union([z.string(), z.number()])
    .transform(val => {
        if (val === '' || val === null || val === undefined) return undefined;
        const num = Number(val);
        return isNaN(num) ? undefined : Math.round(num);
    })
    .pipe(z.number().int().optional());

// Ingredient Schema
export const IngredientSchema = z.object({
    name: z.string().min(1, 'Ingredient name is required'),
    quantityDisplay: z.string().nullable().optional(),
    quantityNumeric: z.number().optional(),
    unitText: z.string().nullable().optional(),
    standardUnitId: z.string().uuid().optional(),
    densityFactor: z.number().positive().optional(),
    usdaId: z.number().int().positive().optional(),
});

export type Ingredient = z.infer<typeof IngredientSchema>;

// Family Group Schema (legacy/deprecated but kept for compatibility)
export const FamilyGroupSchema = z.object({
    id: z.string(),
    name: z.string(),
    members: z.array(z.string()),
});

export type FamilyGroup = z.infer<typeof FamilyGroupSchema>;

// Profile Schema
export const ProfileSchema = z.object({
    id: z.string(),
    name: z.string(),
    age: z.number(),
    dietaryRestrictions: z.array(z.string()).optional(),
});

export type Profile = z.infer<typeof ProfileSchema>;